/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {combineEpics, Epic} from 'redux-observable';
import {filter, ignoreElements, map, mapTo, mergeMap, tap} from 'rxjs/operators';
import {isActionOf} from 'typesafe-actions';
import {
	resetPasswordSceneAccountNameSubmitted,
	resetPasswordSceneAccountRecoveryUnexpectedError,
	resetPasswordSceneBackButtonClicked,
	resetPasswordSceneRecoveryStarted,
	resetPasswordSceneStartAccountRecoveryValidationException
} from '../scenes/ResetPassword/actions';
import {Route as LoginUIRoute} from '../routes';
import {
	iamApiAccountRecoveryStarted,
	iamApiStartAccountRecoveryUnexpectedError,
	iamApiStartAccountRecoveryValidationException
} from '../services/IamApi/actions';
import {accountRecoveryResource} from '../services';
import {violationsWithErrorMessages} from '../model/validation';
import {navigate} from '../components/OutHook';

const navigateToLoginRouteOnBackButtonClicked: Epic = (action$) => action$.pipe(
	filter(isActionOf(resetPasswordSceneBackButtonClicked)),
	tap(() => navigate(LoginUIRoute.LOGIN)),
	ignoreElements()
);

const startAccountRecoveryOnAccountNameSubmitted: Epic = (action$) => action$.pipe(
	filter(isActionOf(resetPasswordSceneAccountNameSubmitted)),
	mergeMap((action) => accountRecoveryResource.startAccountRecovery(action.payload.command))
);

const notifySceneOfAccountRecoveryStarted: Epic = (action$) => action$.pipe(
	filter(isActionOf(iamApiAccountRecoveryStarted)),
	mapTo(resetPasswordSceneRecoveryStarted())
);

const notifySceneOfAccountRecoveryValidationException: Epic = (action$) => action$.pipe(
	filter(isActionOf(iamApiStartAccountRecoveryValidationException)),
	map((action) => {
		const violations = violationsWithErrorMessages(action.payload.violations);

		return resetPasswordSceneStartAccountRecoveryValidationException({
			violations: {
				accountName: violations.accountName || []
			}
		});
	})
);

const notifySceneOfStartAccountRecoveryUnexpectedError: Epic = (action$) => action$.pipe(
	filter(isActionOf(iamApiStartAccountRecoveryUnexpectedError)),
	mapTo(resetPasswordSceneAccountRecoveryUnexpectedError())
);

const resetPasswordEpics: Epic = combineEpics(
	navigateToLoginRouteOnBackButtonClicked,
	startAccountRecoveryOnAccountNameSubmitted,
	notifySceneOfAccountRecoveryStarted,
	notifySceneOfAccountRecoveryValidationException,
	notifySceneOfStartAccountRecoveryUnexpectedError
);

export default resetPasswordEpics;
